import React from 'react';
import {Link} from 'react-router-dom';
import '../styles/HomePage.css';

function NotFoundPage(){

  return(

    <div className="homepage-container">

      <section className="workforce-hero fade-in">

        <div className="hero-content">

          <p className="eyebrow">
            404 Error
          </p>

          <h1>
            Page Not Found
          </h1>

          <p>
            Sorry, the page you're looking for doesn't exist or may have been moved.
          </p>

          <div className="hero-actions">

            <Link
              to="/"
              className="primary-btn"
              style={{textDecoration:'none'}}
            >
              Back to Home
            </Link>

            <Link
              to="/contact"
              className="secondary-btn"
              style={{textDecoration:'none'}}
            >
              Contact Us
            </Link>

          </div>

        </div>

      </section>

    </div>

  );

}

export default NotFoundPage;